import { trackCustomEvent } from './helper.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const API_RESPONSE_TIME_BUCKETS = [
  {
    value: 200,
    label: "0 - 200"
  },
  {
    value: 500,
    label: "200 - 500"
  },
  {
    value: 800,
    label: "500 - 800"
  },
  {
    value: 1e3,
    label: "800 - 1000"
  },
  {
    value: 1500,
    label: "1000 - 1500"
  },
  {
    value: 2e3,
    label: "1500 - 2000"
  },
  {
    value: 3e3,
    label: "2000 - 3000"
  },
  {
    value: 4e3,
    label: "3000 - 4000"
  },
  {
    value: 5e3,
    label: "4000 - 5000"
  },
  {
    value: 8e3,
    label: "5000 - 8000"
  },
  {
    value: 1e4,
    label: "8000 - 10000"
  },
  {
    value: 11e3,
    label: "> 10000"
  }
];
const getBucket = (responseTime) => {
  let low = 0;
  let high = API_RESPONSE_TIME_BUCKETS.length - 1;
  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    if (responseTime <= API_RESPONSE_TIME_BUCKETS[mid].value) {
      high = mid;
    } else {
      low = mid + 1;
    }
  }
  return API_RESPONSE_TIME_BUCKETS[low].label;
};
const trackResponseTimeAsync = (contentName, duration, property) => {
  setTimeout(() => {
    trackCustomEvent(contentName, {
      action: "apiCallTime",
      category: "teko-web",
      label: getBucket(duration),
      value: duration,
      property: property ? typeof property === "string" ? property : JSON.stringify(property) : void 0
    });
  }, 0);
};
const trackInvalidResponseTimeAsync = (contentName, property) => {
  setTimeout(() => {
    trackCustomEvent(contentName, {
      action: "invalid-apiCallTime",
      category: "teko-web",
      property: property ? typeof property === "string" ? property : JSON.stringify(property) : void 0
    });
  }, 0);
};
const trackResponseTimeWithStartAt = (url, startAt, property) => {
  const contentName = String(url) || "undefined_url";
  const startAtNum = Number(startAt);
  if (!!startAt && !isNaN(startAtNum)) {
    const duration = Math.round(performance.now()) - startAtNum;
    trackResponseTimeAsync(contentName, duration, property);
  } else {
    trackInvalidResponseTimeAsync(contentName, property);
  }
};
const requestDurationTrackingInterceptor = (request) => {
  request.headers.set("meta_data", JSON.stringify({
    start_at: Math.round(performance.now())
  }));
};
const responseDurationTrackingInterceptor = (request, response) => {
  var _a;
  const { code, data } = response;
  const { body, method, params, url, headers: requestHeaders } = request;
  const headers = Object.fromEntries(new Headers(requestHeaders).entries());
  const traceId = data.traceId || "not_available";
  const message = data.message;
  const startAt = !!(headers == null ? void 0 : headers.meta_data) ? JSON.parse(headers.meta_data).start_at : void 0;
  const dataTracking = {
    headers: __spreadProps(__spreadValues({}, headers), {
      authorization: !!((_a = headers == null ? void 0 : headers.authorization) == null ? void 0 : _a.length) ? "token" : ""
    }),
    body,
    params,
    method,
    traceId,
    message,
    code,
    isFulfilled: !(code >= 400)
  };
  trackResponseTimeWithStartAt(url, startAt, dataTracking);
};

export { requestDurationTrackingInterceptor, responseDurationTrackingInterceptor, trackResponseTimeWithStartAt };
